<template>
  <div style="position: relative">
    <!--    input框-->
    <a-icon class="a-icon" type="plus-circle"/>
    <div class="ant-input fix" @click="openModal" v-if="!disabled">
      <template v-for="(item,index) in checkedList">
        <a-tooltip :key="index" :title="item.codeName">
          <div class="input_data l fix" :key="index">
            <div class="l">
              {{ item.codeName }}
            </div>
            <div class="l dele_btn" @click.stop="itemClose(item)">×</div>
          </div>
        </a-tooltip>
      </template>
      <div class="input_data l" v-if="checkedList.length" @click.stop="closeAll">删除全部</div>

    </div>
    <div class="ant-input" style="height: auto;min-height: 32px;background-color: #eee" v-else>

    </div>
    <!--    客户属性列表弹窗-->

    <a-modal forceRender
             v-model="visible"
             :title="title"
             :width="1200"
             ok-text="确认"
             cancel-text="取消"
             @ok="handleOk"
             @cancel="cancelPop"
    >

      <div class="attributes-select " >
        <!--        一级分类-->
        <div class="parents_type fix" v-for="(item,index) in list"
             :key="index">
          <div class="type_item">
            {{ item.name }}
          </div>
          <div class="second_item l"
               v-for="(dataListItem,dataListIndex) in item.dataList"
               :class="dataListItem.isChecked?'on':null"
               :key="dataListIndex"
               @click="chooseData(index,dataListIndex,dataListItem)">
            {{ dataListItem.codeName }}
          </div>

        </div>

      </div>
    </a-modal>
  </div>

</template>

<script>
import {dataApi} from '@/services/comm/customerAttributes.js';
// import XEUtils from "xe-utils";

export default {

  data() {
    return {
      visible: false,
      list: [],
      checkedData: [],//选中的数据
      // dataList:[],//取消弹窗预存数据
    }
  },
  model: {
    prop: 'value',
    event: 'custNatureNames'
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Array,
      default() {
        return []
      }
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    /**
     * input数据
     */
    checkedList() {
      let arr = [];
      this.checkedData.forEach((item, index) => {
        item.forEach(i => {
          i.parentIndex = index;
          i.isChecked = true
          arr.push(i)
        })
      })
      return arr
    },
    /**
     * 防止取消input不显示
     */
    dataList(){
      return this.value
    },
  },
mounted() {
  this.list = [];
  this.checkedData = this.value
  this.getAttributesList(); // 用户属性接口
},
  methods: {
    /**
     * 选中二级
     * @param index 父级索引
     * @param idx 子类索引
     * @param items 子类数据
     */
    chooseData(index, idx, items) {
      this.$set(this.list[index].dataList, idx, Object.assign({}, items, {isChecked: !items.isChecked}))

    },
    //显示客户属性弹窗
    openModal() {
      this.visible = true;
      // this.list = [];
      // this.checkedData = []
      this.getAttributesList(); // 用户属性接口
    },

    getCheckHandler() {
      this.checkedData = []
      for (let i = 0; i < this.list.length; i++) {
        // let item = this.list[i]
        let choose = this.list[i].dataList.filter(item => {
          return item.isChecked
        })
        this.checkedData.push(choose)
      }
      this.$emit('custNatureNames', this.checkedData)
    },

    //点击确定回调
    handleOk() {
      this.getCheckHandler();
      this.visible = false
    },
    /**
     * 取消弹窗
     */
    cancelPop(){
      this.list = [];
      this.checkedData = this.dataList
    },

    /**
     * input删除某一条属性
     */
    itemClose(removedItem) {
      let idx = this.list[removedItem.parentIndex].dataList.findIndex(item => {
        return item.codeId == removedItem.codeId
      })

      this.$set(this.list[removedItem.parentIndex].dataList, idx, Object.assign({}, removedItem, {isChecked: !removedItem.isChecked}))
      this.getCheckHandler()

    },
    /**
     *删除全部选中属性
     */
    closeAll() {
      this.checkedData = [];
      this.$emit('custNatureNames', [[], [], [], [], []])

    },
    /**
     * 获取客户属性
     */
    getAttributesList() {
      dataApi.getAttributesList().then(res => {
        if (this.value.length) { //如果详情页
          res.data.forEach((item, index) => {
            item.dataList.forEach(i => {
              let idx = this.value[index].findIndex(v => {
                return v.codeId == i.codeId
              })
              if (idx >= 0) {
                i.isChecked = true
              }
            })
          })
        }
        this.list = res.data
      })
    }
  },
};
</script>
<style scoped lang="less">
.ant-input {
  height: auto;
  min-height: 32px;
  min-width: 200px;
}

.a-icon {
  position: absolute;
  z-index: 10;
  right: 6px;
  top: 13px;
  pointer-events: none;
}

input {
  cursor: pointer
}

//input上标签样式
.input_data {
  padding: 0 7px;
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  cursor: pointer;
  opacity: 1;
  margin: 3px;

  .dele_btn {
    font-size: 17px;
    line-height: 17px;
    margin-left: 8px;
    color: rgba(0, 0, 0, 0.45);
  }


}

//客户属性选项
.attributes-select {

  .parents_type {

    .type_item {
      font-size: 14px;
      font-weight: bold;
      color: #333;
      margin: 10px 0;
    }

    .second_item {
      display: inline-block;
      background-color: #E9F5FC;
      color: #3DA2FB;
      border-radius: 8px;
      padding: 8px 24px;
      margin: 4px;
      cursor: pointer;
    }

    .second_item.on {
      background-color: #3DA2FB;
      color: #fff;
    }
  }
}


</style>

